import { defineStore } from 'pinia'

// Global loading spinner state. Reference-COUNTED (not a plain boolean) so that
// overlapping async operations can't desync it: two concurrent show()s require
// two hide()s before the overlay comes down. `active` is derived from the count.
//
// This store is intentionally NOT persisted — a stuck count must never survive a
// reload. reset() is the hard escape hatch used by the global error handler and
// the plugin watchdog to guarantee the full-screen overlay can't strand the UI.
export const useSpinnerStore = defineStore('spinner', {
  state: () => ({
    count: 0,
  }),
  getters: {
    active: (state) => state.count > 0,
  },
  actions: {
    show() {
      this.count++
    },
    hide() {
      this.count = Math.max(0, this.count - 1)
    },
    reset() {
      this.count = 0
    },
  },
})
